import React, { Component } from 'react';
import Link from 'gatsby-link';
import ChapterImage from './ChapterImage';
import IntroWithButton from '../global/IntroWithButton';
import style from './ChapterCarousel.module.scss';

class ChapterCarousel extends Component {
  registerChapterImage = elem => {
    this.chapterImage = elem;
  };

  registerChapterText = elem => {
    this.chapterText = elem;
  };

  getImagePath() {
    const imageData1 =
      this.props.exhibition_sections[0].image.sizes &&
      this.props.exhibition_sections[0].image.sizes.large;
    if (imageData1) {
      return imageData1;
    } else {
      const imageData2 =
        this.props.exhibition_sections[0].images[0].sizes &&
        this.props.exhibition_sections[0].images[0].sizes.large;
      if (imageData2) {
        return imageData2;
      } else {
        console.warn("couldn't find exhibition slider image in ", chapter);
      }
    }
  }

  render() {
    const {
      index,
      exhibition_sections,
      title,
      subtitle,
      path,
      color_theme,
      show,
      textExit,
      handleChapterClick,
      headerExit,
      textTransitioning,
      hideTextWrap,
    } = this.props;

    return (
      <div className={style.chapterCarousel}>
        <div
          style={{
            opacity: hideTextWrap ? 0 : 1,
          }}
          className={`${style.chapterInfoWrapper} ${
            headerExit ? style.headerExit : ''
          }`}
        >
          <IntroWithButton
            kicker={`Chapter ${index + 1}`}
            title={title}
            path={path}
            subtitle={subtitle}
            colorTheme={color_theme}
            index={index}
            doSplitText={true}
            noPad
            noMobileRule
            startHidden
            show={show}
            textExit={textExit}
            buttonText="Enter"
            handleClick={handleChapterClick}
            textTransitioning={textTransitioning}
          />
        </div>

        {/* left this in there and made it transparent... so there's a dom
        element to match pixi... feels ok I guess*/}
        <ChapterImage
          imagePath={this.getImagePath()}
          imageAlt={exhibition_sections[0].image.alt}
        />
      </div>
    );
  }
}

export default ChapterCarousel;



// WEBPACK FOOTER //
// ./src/components/exhibition/ChapterCarousel.js